<script setup>
import axios from 'axios';
import { BAlert, BLink, BModal } from 'bootstrap-vue-next';
import { ref } from 'vue';

const model = defineModel({ type: Boolean });
const emit = defineEmits(['accepted', 'disqualified']);

const submitting = ref(false);
const errorMessage = ref(null);

const clearError = () => {
  errorMessage.value = null;
};

const handleAccept = async (event) => {
  event.preventDefault();

  if (submitting.value) {
    return;
  }

  submitting.value = true;
  errorMessage.value = null;

  try {
    await axios.post('/api/v1/hackathon_registrations');

    emit('accepted');
    model.value = false;
  } catch (error) {
    if (error.response?.status === 403) {
      emit('disqualified');
    } else {
      errorMessage.value = 'Something went wrong recording your acceptance. Please try again.';
    }
  } finally {
    submitting.value = false;
  }
};
</script>

<template>
  <BModal
    v-model="model"
    title="Hackathon rules"
    ok-only
    ok-title="I have read the rules and agree"
    @ok="handleAccept"
    @hidden="clearError"
  >
    <BAlert
      :model-value="errorMessage != null"
      variant="danger"
      class="mb-3"
    >
      {{ errorMessage }}
    </BAlert>
    <p>
      Your contributions only count towards the hackathon leaderboard and prizes
      if you agree to the hackathon rules.
    </p>
    <p>
      <BLink
        :to="{ name: 'documentation', params: { page: 'hackathon-rules' } }"
        target="_blank"
      >
        Read the hackathon rules
      </BLink>
    </p>
    <p class="text-muted small">
      You can keep browsing this page without accepting, but your contributions will not
      count towards the hackathon until you do.
    </p>
  </BModal>
</template>
